import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faPlus as plus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
} from "@mui/material";
import React, { memo, useMemo, useState, useRef } from "react";
import { useFormik } from "formik";
import {
    payloadEnviarWhatsapp,
    RespostaModalEnviarWhatsapp,
} from "app/types/modalImprimir/RespostaModalImprimir";
import { EditorDeTexto } from "../../../../editorTexto/EditorDeTexto";
import SelecionarCodigoTelefoneInternacional, {
    CountryCode,
} from "app/components/selecionarCodigoTelefoneInternacional/SelecionarCodigoTelefoneInternacional";
import { listaCodigoInternacionalTelefone } from "app/utils/ListaCodigoInternacionalTelefone";
import { InputMascaraDinamica } from "app/components/inputs/InputMascaraDinamica";
import clsx from "clsx";
import globalMU from "globalMU";
import { TooltipMU } from "app/components/tooltip/TooltipMU";
import { PaperArrastavel } from "../../../../dialog-arrastavel/PaperArrastavel";

const estiloModalEnviarWhatsapp =
    require("./modalEnviarWhatsapp.module.scss").default;

const vermelhoMu = "#D21C1C";
const vermelhoMuAlpha = "rgba(210, 28, 28, 0.90)";
const azulMu = "#0172CB";
const azulClaro = "#e3f2fd";
const vermelhoFillMu = "#F8DBDB";
const vermelhoClaro = "#f8dbdb";
const AmareloMu = "#EFCA08";
const AmareloMuAlpha = "rgba(239, 202, 8, 0.90)";

export type RemetenteWhatsapp = "padrao" | "vendedor";

export type ModalEnviarWhatsappProps = {
    RespostaModalEnviarWhatsapp?: RespostaModalEnviarWhatsapp;
    PermitidoAnexarEmail: boolean;
    Anexos: any;
    PermitidoCopia: boolean;
    PermitidoCopiaOculta: boolean;
    PermitidoAlterarAssunto: boolean;
    PermitidoAlterarMensagem: boolean;
    urlTemplate?: string;
    numeroSincronizadoWhatsappVendedor?: string;
    remetente: RemetenteWhatsapp;
    alterarRemetenteBloqueado?: boolean;
    exibirEscolhaRemetente?: boolean;
    ListaTelefoneCopia: string;
    WhatsappCadastradoVendedor: string;
    whatsappPadraoDesconfigurado?: boolean;
    fallbackWhatsappPadrao?: boolean;
    onClose: () => void;
    onEnviarWhatsapp: (dados: payloadEnviarWhatsapp) => void;
    onAlterarTelefoneCopia: (telefoneCopia: string) => void;
    onAnexar: (event) => void;
    onRemoverAnexo: (AnexoRemovido: any, pos: number) => void;
    onRemoverWhatsappVendedor?: () => void;
    onChangeRemetente: (remetente: RemetenteWhatsapp) => void;
};

export const ModalEnviarWhatsapp = memo((props: ModalEnviarWhatsappProps) => {
    const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
    const hiddenFileInput = useRef(null);
    
    const [countryCode, setCountryCode] = useState(
        listaCodigoInternacionalTelefone.find((c) => c.code === "BR") ??
            listaCodigoInternacionalTelefone[0]
    );

    const formik = useFormik({
        initialValues: {
            ...props.RespostaModalEnviarWhatsapp,
        },
        onSubmit: (values, {}) => {},
        enableReinitialize: true,
    });
    const handleClickAnexar = () => {
        hiddenFileInput.current.click();
    };

    const validarTelefone = (telefone: string) => {
        if (!telefone) return false;

        const numero = telefone.replace(/\D/g, ""); // remove todos os caracteres não numéricos
        const comecaComZero = numero.startsWith("0");
        const comprimentosEsperados = comecaComZero ? [11, 12] : [10, 11];
        return comprimentosEsperados.includes(numero.length);
    };

    const tabelaAnexos = (
        <table className={estiloModalEnviarWhatsapp.informacoesAnexos}
            id="modalEnviarWhatsapp_TabelaAnexos"
        >
            <tbody
                id="modalEnviarWhatsapp_CorpoTabelaAnexos"
            >
                {props.RespostaModalEnviarWhatsapp?.Anexos?.map(
                    (Anexo, index) => (
                        <tr
                            key={`modalEnviarWhatsapp__${index}`}
                            id={`modalEnviarWhatsapp__${index}`}
                        >
                            <td>
                                <a
                                    title={Anexo.NomeArquivo}
                                    href={props?.urlTemplate}
                                    download={Anexo.NomeArquivo}
                                    id={`modalEnviarWhatsapp_LinkAnexoResposta_${index}`}
                                >
                                    {Anexo.NomeArquivo}
                                </a>
                            </td>
                        </tr>
                    )
                )}
                {props?.Anexos?.map((Anexo, pos) => (
                    <tr
                        key={`modalEnviarWhatsapp_Anexo_${pos}`}
                        id={`modalEnviarWhatsapp_Anexo_${pos}`}
                    >
                        <td
                            id={`modalEnviarWhatsapp_NomeAnexo_${pos}`}
                        >
                            <p title={Anexo?.name}>{Anexo?.name}</p>
                        </td>
                        <td
                            id={`modalEnviarWhatsapp_TamanhoAnexo_${pos}`}
                        >
                            <p
                                className={
                                    estiloModalEnviarWhatsapp.tamanhoAnexo
                                }
                            >
                                {" " + (Anexo?.size / 1024).toFixed(2) + " KB"}
                            </p>
                        </td>
                        <td
                            id={`modalEnviarWhatsapp_AcaoAnexo_${pos}`}
                        >
                            <button
                                id={`modalEnviarWhatsapp_BotaoRemoverAnexo_${pos}`}
                                key={`modalEnviarWhatsapp_BotaoRemoverAnexo_${pos}`}
                                className={
                                    estiloModalEnviarWhatsapp.botaoRemoverAnexo
                                }
                                onClick={() => props.onRemoverAnexo(Anexo, pos)}
                            >
                                <FontAwesomeIcon icon={faBan} />
                                Remover
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
    const erroNumeroVendedor = useMemo<boolean>(() => {
        if (props.remetente != "vendedor"){
            return false;
        }
        if (globalMU.isNullOrEmpty(props.numeroSincronizadoWhatsappVendedor) || globalMU.isNullOrEmpty(props.WhatsappCadastradoVendedor)) {
            return true;
        }
        if (!props.numeroSincronizadoWhatsappVendedor) {
            return true;
        }

        if(!props.WhatsappCadastradoVendedor){
            return true;
        }

        if( props.numeroSincronizadoWhatsappVendedor &&  props.remetente === "vendedor"){
            let numeroWhatsappSemDdi= props.numeroSincronizadoWhatsappVendedor;
            if(numeroWhatsappSemDdi.startsWith("+")){
                numeroWhatsappSemDdi = props.numeroSincronizadoWhatsappVendedor.substring(1);
            }
            if(numeroWhatsappSemDdi?.startsWith("55")){
                numeroWhatsappSemDdi = props.numeroSincronizadoWhatsappVendedor.substring(2);
            }
            if(numeroWhatsappSemDdi?.startsWith("0")){
                numeroWhatsappSemDdi = numeroWhatsappSemDdi.substring(1);
            }
            let numeroWhatasppSemDDD = numeroWhatsappSemDdi.substring(2);
            let ddd = numeroWhatsappSemDdi.substring(0,2);

            let numeroCadastradoSemDdi = props.WhatsappCadastradoVendedor;
            if(numeroCadastradoSemDdi.startsWith("+")){
                numeroCadastradoSemDdi = numeroCadastradoSemDdi.substring(1);
            }
            if(numeroCadastradoSemDdi?.startsWith("55")){
                numeroCadastradoSemDdi = numeroCadastradoSemDdi.substring(2);
            }
            if(numeroCadastradoSemDdi?.startsWith("0")){
                numeroCadastradoSemDdi = numeroCadastradoSemDdi.substring(1);
            }

            let numeroCadastradoSemDDD = numeroCadastradoSemDdi.substring(2);

            if(numeroWhatasppSemDDD == numeroCadastradoSemDDD || ("9"+numeroWhatasppSemDDD) == numeroCadastradoSemDDD || numeroWhatasppSemDDD == ("9"+numeroCadastradoSemDDD)){
                return false;
            }

            if(props.numeroSincronizadoWhatsappVendedor != props.WhatsappCadastradoVendedor){
                return true;
            }
        }
        return false;
    }, [props.remetente, props.numeroSincronizadoWhatsappVendedor, props.WhatsappCadastradoVendedor]);


    const CardNumeroVendedor = (
        <div
            id="modalEnviarWhatsapp_CardNumeroVendedor"
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: erroNumeroVendedor ? vermelhoClaro : azulClaro,
                height: "80px",
                // opacity: 0.7,
                marginBottom: "1rem",
                borderRadius: "4px",
            }}
        >
            <p
                id="modalEnviarWhatsapp_NumeroVendedor"
                style={{
                    padding: "10px",
                    fontSize: "15px",
                    color: erroNumeroVendedor ? vermelhoMu :azulMu,
                    fontWeight: 500, // azul escuro
                }}
            >
                {" "}
                O número do WhatsApp sincronizado é {" "}<strong>{props.numeroSincronizadoWhatsappVendedor}.</strong>
                {erroNumeroVendedor ? " Porém o WhatsApp cadastrado para a pessoa física do vendedor é ": undefined} {erroNumeroVendedor && <strong>{globalMU.isNullOrEmpty(props.WhatsappCadastradoVendedor) ? "[NENHUM]" : props.WhatsappCadastradoVendedor}.</strong>}
            </p>
            <button
                id="modalEnviarWhatsapp_BotaoRemoverWhatsappVendedor"
                style={{
                    // backgroundColor: "var(--mu-superficie, #fff)",
                    // color: azulMu,
                    // border: "2px solid #azulMu",
                    padding: "6px 1rem",
                    borderRadius: "4px",
                    cursor: "pointer",
                    height: "fit-content",
                    marginRight: "20px",
                }}
                className={clsx(
                    "no-global-button",
                   erroNumeroVendedor ? estiloModalEnviarWhatsapp.botaoRemoverWhatsappVendedorErro: estiloModalEnviarWhatsapp.botaoRemoverWhatsappVendedor
                )}
                onClick={() => props.onRemoverWhatsappVendedor()}
            >
                <strong>Remover</strong>
            </button>
        </div>
    );
    const mensagemErroSessaoPadraoDesconfigurada =  "A Sessão Padrão Do WhatsApp não está conectada.";
    
    const tooltipSessaoPadraoDesconfigurado = (
            <TooltipMU
                    title={
                        <>
                            <p>
                                {mensagemErroSessaoPadraoDesconfigurada}
                            </p>
                        </>
                    }
                    style={{ backgroundColor: vermelhoMuAlpha }}
                    color={vermelhoMuAlpha}
                >
                    <div
                        style={{
                            display: "inline",
                        }}
                    >
                        <FontAwesomeIcon
                            cursor={"pointer"}
                            icon={faCircleExclamation}
                            color={vermelhoMuAlpha}
                            fontSize={"18px"}
                            style={{ marginTop: "3px", marginLeft: "5px" }}
                        />
                    </div>
                </TooltipMU>    )

    const mensagemFallbackSessaoPadrao =  "A sessão da filial não está configurada. A mensagem WhatsApp será enviada pelo pelo número Padrão.";

    const tooltipFallbackSessaoPadrao = (
            <TooltipMU
                    title={
                        <>
                            <p>
                                {mensagemFallbackSessaoPadrao}
                            </p>
                        </>
                    }
                    style={{ backgroundColor: AmareloMu }}
                    color={AmareloMu}
                >
                    <div
                        style={{
                            display: "inline",
                        }}
                    >
                        <FontAwesomeIcon
                            cursor={"pointer"}
                            icon={faTriangleExclamation}
                            color={AmareloMu}
                            fontSize={"18px"}
                            style={{ marginTop: "3px", marginLeft: "5px" }}
                        />
                    </div>
                </TooltipMU>    )
    const obterTitleOpcaoSessaoPadrao = useMemo<string | undefined>(() => {
        if(props.whatsappPadraoDesconfigurado && props.remetente == "padrao") {
            return mensagemErroSessaoPadraoDesconfigurada;
        }
        else if (props.fallbackWhatsappPadrao && props.remetente == "padrao") {
            return mensagemFallbackSessaoPadrao;
        }
        return undefined;
    }, [props.whatsappPadraoDesconfigurado, props.remetente, props.fallbackWhatsappPadrao]);
    const escolherRemetente = (
        <>
            <h4 style={{ fontWeight: 700 }}>Remetente</h4>
            <RadioGroup
                id={`modalEnviarWhatsapp_RadioGroupRemetente`}
            >
                <FormControlLabel
                    style={{
                        color: props.whatsappPadraoDesconfigurado && props.remetente == "padrao" ? vermelhoMu : undefined,
                    }}
                    control={
                        <Radio
                            value="padrao"
                            checked={props.remetente == "padrao"}
                            onChange={() => props.onChangeRemetente("padrao")}
                            style={{
                                color: props.alterarRemetenteBloqueado
                                    ? "#bdbdbd"
                                    : props.remetente === "padrao"
                                    ? props.whatsappPadraoDesconfigurado && props.remetente === "padrao" 
                                        ? vermelhoMu
                                        : azulMu
                                    : undefined ,
                            }}
                            disabled={props.alterarRemetenteBloqueado}
                            title={obterTitleOpcaoSessaoPadrao}
                        />
                    }
                    label={
                        <>
                            <span
                                    style={{ fontWeight: props.whatsappPadraoDesconfigurado && props.remetente === "padrao" ? "bold" : undefined }}
                                    title={obterTitleOpcaoSessaoPadrao}
                                >
                                    WhatsApp Loja (Padrão)
                            </span>
                            { props.whatsappPadraoDesconfigurado && props.remetente === "padrao" ? tooltipSessaoPadraoDesconfigurado : null}
                            {props.fallbackWhatsappPadrao && props.remetente === "padrao" ? tooltipFallbackSessaoPadrao : null}
                        </>
                    }
                />
                <FormControlLabel
                    style={{
                        color: erroNumeroVendedor ? vermelhoMu : undefined,
                    }}
                    
                    control={
                        <Radio
                        
                            value="vendedor"
                            checked={props.remetente == "vendedor"}
                            onChange={() => props.onChangeRemetente("vendedor")}
                            onClick={() => {
                                props.onChangeRemetente("vendedor");
                            }}
                            style={{
                                color: props.alterarRemetenteBloqueado
                                    ? "#bdbdbd"
                                    : props.remetente === "vendedor"
                                    ? erroNumeroVendedor
                                        ? vermelhoMu
                                        : azulMu
                                    : erroNumeroVendedor ? vermelhoMu : undefined,
                            }}
                            disabled={props.alterarRemetenteBloqueado}
                        />
                    }
                    label={<span style={{ fontWeight: erroNumeroVendedor ? "bold" : undefined }}>WhatsApp Vendedor</span>}
                />
            </RadioGroup>

            {globalMU.isNotNullOrEmpty(props.numeroSincronizadoWhatsappVendedor) && props.remetente === "vendedor" && 
                CardNumeroVendedor}

            <Divider
                style={{
                    marginBottom: "1rem",
                    borderColor: "#409fff",
                }}
            />
            <h4 style={{ fontWeight: 700 }}>Mensagem</h4>
            <br />
        </>
    );

    const conteudoModal = (
        <div className={estiloModalEnviarWhatsapp.conteudoModal}>
            {props.exibirEscolhaRemetente && escolherRemetente}


            <div
                id="modalEnviarWhatsapp_DivInformacoesEnviarWhatsapp"
                className={estiloModalEnviarWhatsapp.InformacoesEnviarWhatsapp}
            >
                <label className={estiloModalEnviarWhatsapp.primeiraColuna}>
                    Telefone
                </label>

                <SelecionarCodigoTelefoneInternacional
                    value={countryCode}
                    onChange={(value: CountryCode) => setCountryCode(value)}
                    style={{
                        marginLeft: "1rem",
                    }}
                    onLimpar={() => setCountryCode(null)}
                    disabled={!props.PermitidoCopia}
                />
                <InputMascaraDinamica
                    id="modalEnviarWhatsapp_InputTelefone"
                    disabled={!props.PermitidoCopia}
                    name="Telefone"
                    className={
                        validarTelefone(formik.values.Telefone)
                            ? estiloModalEnviarWhatsapp.Telefone
                            : estiloModalEnviarWhatsapp.TelefoneComErro
                    }
                    valor={formik.values.Telefone}
                    onValorModificado={(value) => {
                        value != null
                            ? formik.setFieldValue(
                                  "Telefone",
                                  globalMU.removerLetrasESimbolos(value)
                              )
                            : formik.setFieldValue("Telefone", "");
                    }}
                    mascaras={
                        formik.values.Telefone?.startsWith("0") ||
                        formik.values.Telefone?.startsWith("(0")
                            ? ["(999) 9999-9999", "(999) 99999-9999"]
                            : ["(99) 9999-9999", "(99) 99999-9999"]
                    }
                />
            </div>
            <div
                className={estiloModalEnviarWhatsapp.InformacoesEnviarWhatsapp}
                style={{ alignItems: "center" }}
            >
                <label
                    className={estiloModalEnviarWhatsapp.primeiraColuna}
                    style={{ alignContent: "center" }}
                >
                    Telefone(s) Cópia
                </label>

                <input
                    id="modalEnviarWhatsapp_InputTelefoneCopia"
                    type="text"
                    disabled={!props.PermitidoCopia}
                    name="ListaTelefoneCopia"
                    // className={ validarTelefone(formik.values.Telefone)  ?  estiloModalEnviarWhatsapp.Telefone : estiloModalEnviarWhatsapp.TelefoneComErro}
                    defaultValue={props.ListaTelefoneCopia}
                    value={(props.ListaTelefoneCopia) ?? ""}
                    onChange={(event) => {
                        props.onAlterarTelefoneCopia(event.target.value);
                    }}
                    style={{
                        width: "100%",
                        marginLeft: "1rem",
                        textAlign: "left",
                    }}
                    title="Use vírgula para separar os números como no exemplo: (99) 9999-9999, (99) 99999-9999
                    Caracteres diferentes de numeros e da virgula são desconsiderados"
                />

                <TooltipMU
                    title={
                        <>
                            <p>
                                Use esse campo para enviar cópias do WhatsApp
                                para outros números.
                            </p>
                            <br />
                            <p>
                                Se você não quiser enviar cópias, deixe esse
                                campo em branco.
                            </p>

                            <br />
                            <p>
                                Use a{" "}
                                <strong>
                                    <b>vírgula</b>
                                </strong>{" "}
                                para separar os números como no exemplo abaixo:
                            </p>
                            <br />

                            <p>(99) 9999-9999, (99) 99999-9999</p>
                            <br />
                            <br />
                            <br />

                            <p>
                                <strong>
                                    <b>
                                        Obs: Caracteres diferentes de números e
                                        da vírgula são desconsiderados.
                                    </b>
                                </strong>
                            </p>
                        </>
                    }
                    style={{ backgroundColor: "#409fff" }}
                    color="#409fff"
                >
                    <div
                        style={{
                            display: "inline",
                        }}
                    >
                        <FontAwesomeIcon
                            cursor={"pointer"}
                            icon={faCircleInfo}
                            color="#409fff"
                            fontSize={"18px"}
                            style={{ marginTop: "3px", marginLeft: "5px" }}
                        />
                    </div>
                </TooltipMU>
            </div>
            <br />
            <EditorDeTexto
                permitidoAlterarMensagem={props.PermitidoAlterarMensagem}
                onChange={(texto) => formik.setFieldValue("Mensagem", texto)}
                mensagem={props?.RespostaModalEnviarWhatsapp?.Mensagem}
                toolbarHidden={false}
                toolbarPersonalizada={{
                    mostraBold: true,
                    mostraItalic: true,
                    mostraStrikethrough: true,
                    mostraEmoji: true,
                    mostraHistorico: true,
                }}
            />
        </div>
    );

    const dialogActions = (
        <DialogActions
            style={{
                justifyContent: "right",
                minWidth: "350px",
            }}
            disableSpacing={true}
            className={estiloModalEnviarWhatsapp.dialogActions}
        >
            <div className={estiloModalEnviarWhatsapp.modalActions}>
                <button
                    id="modalEnviarWhatsapp_BotaoEnviarWhatsapp"
                    className={
                        estiloModalEnviarWhatsapp.buttonModalEnviarWhatsapp
                    }
                    onClick={(e) => {
                        const telefone =
                            (countryCode
                                ? countryCode.dialCode.replace("+", "")
                                : "") + formik.values.Telefone;
                        props.onEnviarWhatsapp({
                            ...formik.values,
                            Telefone: telefone,
                            ListaTelefoneCopia: props.ListaTelefoneCopia,
                        });
                    }}
                    style={{
                        margin: "0 3px 0 0",
                        padding: "7px 1em",
                    }}
                >
                    Enviar
                </button>
                <button
                    id="modalEnviarWhatsapp_BotaoFecharModal"
                    className={
                        estiloModalEnviarWhatsapp.buttonModalEnviarWhatsapp
                    }
                    onClick={props.onClose}
                    style={{
                        margin: "0 3px 0 0",
                        padding: "7px 1em",
                    }}
                >
                    Fechar
                </button>
            </div>
        </DialogActions>
    );

    return (
        <>
            <Dialog
                open={true}
                onClose={props.onClose}
                scroll={scroll}
                className={estiloModalEnviarWhatsapp.dialogModalSenha}
                PaperComponent={PaperArrastavel}
            >
                <div className={estiloModalEnviarWhatsapp.titulo} data-arrastar-dialog>
                    <h4 style={{ fontWeight: 700 }}>Enviar por WhatsApp</h4>
                    <div>
                        <a onClick={props.onClose}>
                            <FontAwesomeIcon
                                icon={faTimes}
                                cursor={"pointer"}
                                className={estiloModalEnviarWhatsapp.exit}
                                opacity={0.2}
                            />
                        </a>
                    </div>
                </div>
                <DialogContent
                    dividers={scroll === "paper"}
                    style={{ padding: "15px" }}
                >
                    {conteudoModal}
                    {props?.PermitidoAnexarEmail && (
                        <button
                            className={`no-global-button ${estiloModalEnviarWhatsapp.botaoAnexar}`}
                            onClick={handleClickAnexar}
                        >
                            <FontAwesomeIcon icon={plus} size="lg" />
                            Anexar
                        </button>
                    )}

                    <input
                        style={{ display: "none" }}
                        type="file"
                        onChange={props.onAnexar}
                        ref={hiddenFileInput}
                    />

                    {tabelaAnexos}
                    <br />
                    {dialogActions}
                </DialogContent>
            </Dialog>
        </>
    );
});
